export const NotifyUser = async ({ title = 'WhatsApp Customer Care', message, icon }) => {
  if (!('Notification' in window)) {
    console.log('Browser does not support notifications!');
    return;
  }

  const showNotification = () => {
    new Notification(title, {
      body: message,
      icon: icon || '/favicon.ico',
    });
  };

  if (Notification.permission === 'granted') {
    showNotification();
  } else if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      showNotification();
    }
  }
};

export const handleNotificationPermission = async () => {
  if (Notification.permission === 'default') {
    await Notification.requestPermission();
  }
};
